import React from 'react';
export function BrandsSection() {
  const brands = ['Somfy', 'Lutron', 'Crestron', 'Hunter Douglas', 'Rollease', 'Vertilux'];
  const scrollBrands = [...brands, ...brands];
  return <section className="bg-sand py-12 sm:py-16 overflow-hidden border-y border-gray-200" data-id="element-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 mb-8 sm:mb-10" data-id="element-25">
        <h2 className="text-xl sm:text-2xl font-bold text-charcoal text-center" data-id="element-26">
          Trusted Brands
        </h2>
      </div>

      <div className="relative overflow-hidden" data-id="element-27">
        <div className="flex animate-scroll w-max" data-id="element-28">
          {scrollBrands.map((brand, index) => <div key={index} className="flex-shrink-0 px-6 sm:px-10 md:px-12 text-xl sm:text-2xl md:text-3xl font-bold text-gray-400 hover:text-gold transition-colors duration-300 cursor-default tracking-wider uppercase whitespace-nowrap" data-id="element-29">
              {brand}
            </div>)}
        </div>
      </div>
    </section>;
}